import { useCountries } from 'hooks/queries/countries';
import formatOptions from 'utils/form/formatOptions';

const useCountriesOptions = () => {
  const { data } = useCountries();

  return { countriesOptions: formatOptions(data) };
};

export default useCountriesOptions;
